import ReactDOM from "react-dom";
import React from "react";
import FAQSearch from "../components/faq-search/FAQSearch";

const init = () => {
  let mountPoint = document.querySelector("#FAQSearch");

  if (mountPoint) {
    ReactDOM.render(<FAQSearch />, mountPoint);
  }
};

// Init on initial page load
init();
